import axios from '@/plugins/axios';

const VIOLATION_REPORT_CATEGORY = '/violation-report-category';
const VIOLATION_REPORT = 'violation-report';

export async function getViolationReportCategory(payload) {
  try {
    const data = await axios.get(`${VIOLATION_REPORT_CATEGORY}`, { params: payload });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function createViolationReport(payload) {
  try {
    const { data } = await axios.post(VIOLATION_REPORT, payload);

    return data;
  } catch (error) {
    return { error };
  }
}
